import css from './UsersModal.module.scss';
import T from '../../../../../../common/components/T';
import { gridThead, transformGridData } from './helpers';
import SearchWindow from '../../../../../searchWindow/SearchWindow';

export default function UsersModal(props) {
    const { closeHandler, onSelect, fastSearch, sendData } = props;
    return (
        <SearchWindow
            closeModal={closeHandler}
            fastSearch={fastSearch}
            customData={{
                buttonNotShow: true
            }}
            gridHandlers={{
                tr: {
                    onClick: onSelect
                }
            }}
            transformSearchData={transformGridData}
            thead={gridThead}
            title={<T textName='search-user' defaultStr='Поиск пользователя' />}
            gridConfig={{
                0: {
                    th: {
                        className: css.w500
                    }
                },
                2: {
                    th: {
                        className: css.w192
                    }
                }
            }}
            sendData={sendData}
        />
    );
}
